import axios from "axios";
import config from "configSite";

const auth = axios.create({
  baseURL: config.apiUrl
});

export default {
  register(inputs) {
    return auth.post("/auth/admin-register", {
      firstname: inputs.firstname,
      lastname: inputs.lastname,
      password: inputs.password,
      email: inputs.email
    });
  },
  authorize(inputs) {
    return auth.post("/admin/login", {
      grant_type: "password",
      username: inputs.username,
      password: inputs.password
    });
  },
  refreshToken(inputs, token) {
    if (!token) return console.log("missing token.");
    return auth.post("/auth/token", {
      grant_type: "refresh_token",
      client_id: config.clientId,
      client_secret: config.secretKey,
      refresh_token: inputs.refresh_token,
      scope: ""
    });
  },
  logout(token) {
    if (!token) return console.log("missing token.");
    return auth.post("/auth/logout", {});
  }
};
